<template>
  <div style="padding: 20px 0 0 0">
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="onSubmit"
      class="demo-form-inline">
      <el-form-item label="发货编号：">
        <div @dblclick="dblclick('deliveryTaskCode')">
          <el-input maxlength='450' v-model="formInline.deliveryTaskCode" placeholder="双击批量搜索"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="商品SKU：">
        <el-input maxlength='450' v-model="formInline.shopProductSkuStr" placeholder="请填入商品SKU"></el-input>
      </el-form-item>
      <el-form-item label="平台SKU：">
        <el-input maxlength='450' v-model="formInline.productSkuStr" placeholder="请填入平台SKU"></el-input>
      </el-form-item>
      <el-form-item label="店铺名称：">
        <el-input maxlength='450' v-model="formInline.customerShopName" placeholder="请填入店铺名称"></el-input>
        <!-- <el-select  filterable placeholder="请选择" multiple remote :remote-method="remoteMethod"  v-model="formInline.customerShopIdList">
          <el-option v-for="item in storeList" :key="item.customerShopId" :label="item.customerShopName" :value="item.customerShopId"> </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="是否可发：" v-if="false">
        <el-select v-model="formInline.canDelivery" placeholder="全部">
          <el-option label="全部" :value="''"></el-option>
          <el-option label="缺货" :value="0"></el-option>
          <el-option label="到齐" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收货国家：">
        <el-select v-model="formInline.receivingNationCode" placeholder="全部" filterable>
          <el-option label="全部" :value='undefined'></el-option>
          <el-option v-for="i in countryList" :key="i.countryCode" :label="i.countryName"
            :value="i.countryCode"></el-option>
        </el-select>
      </el-form-item>
      <!--      只有小件有单多品-->
      <el-form-item label="单/多品：">
        <el-select v-model="formInline.singleProduct" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option label="多品" :value="0"></el-option>
          <el-option label="单品" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：" v-if="tableType != 'builtBag'">
        <el-date-picker v-model="formInline.createDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="timeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="打包时间：" v-if="tableType == 'builtBag'">
        <el-date-picker v-model="formInline.packSDate" type="datetimerange" :default-time="['00:00:00', '23:59:59']"
          range-separator="至" start-placeholder="开始日期" @change="packTimeChange" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发货时间：">
        <el-date-picker v-model="formInline.deliveryDate" type="datetimerange" :default-time="['00:00:00', '23:59:59']"
          range-separator="至" start-placeholder="开始日期" @change="deliveryTimeChange" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="prentType == 'smallBag' && tableType != 'shipped' && tableType != 'abandoned'"
        label="Tiktok发货截止时间：">
        <el-date-picker v-model="formInline.rtsSlaTime" type="datetimerange" :default-time="['00:00:00', '23:59:59']"
          range-separator="至" start-placeholder="开始日期" @change="rtsSlaTimeChange" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="物流单号：">
        <div @dblclick="dblclick('logisticsCodeStr')">
          <el-input maxlength='450' v-model="formInline.logisticsCodeStr" placeholder="双击批量搜索"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="历史物流单号：" v-if="prentType == 'smallBag'">
        <el-input maxlength='50' v-model="formInline.historyLogisticsCodeStr" placeholder="请填入历史物流单号"></el-input>
      </el-form-item>
      <el-form-item label="订单编号：" v-if="prentType == 'smallBag'">
        <el-input maxlength='450' v-model="formInline.platformOrderNoStr" placeholder="请填入订单编号"></el-input>
      </el-form-item>
      <!--      只有大包有三方仓-->
      <el-form-item label="订单来源" v-if="prentType == 'smallBag'">
        <el-select v-model="formInline.orderSource" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option label="直行便" :value='1'></el-option>
          <el-option label="base" :value='2'></el-option>
          <el-option label="shopify" :value='3'></el-option>
          <el-option label="stores" :value='4'></el-option>
          <el-option label="自建独立站" :value='7'></el-option>
          <el-option label="Tiktok" :value='11'></el-option>
        </el-select>
      </el-form-item>
      <!--      只有大包有三方仓-->
      <el-form-item label="发货类型" v-if="prentType == 'largeBag'">
        <el-select v-model="formInline.thirdWarehouseType" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option label="乐天" :value='2'></el-option>
          <el-option label="SHOPLIST" :value='3'></el-option>
          <el-option label="ZOZOTOWN" :value='4'></el-option>
          <el-option label="其他" :value='0'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="扣款状态" v-if="tableType == 'builtBag'">
        <el-select v-model="formInline.payStatus" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option label="扣款负数" :value='3'></el-option>
          <el-option label="未支付" :value='0'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="异常存放位置：" v-if="prentType == 'smallBag' && tableType == 'buildingBag'">
        <el-input maxlength='450' v-model="formInline.exceptionLocation" placeholder="请填入异常存放位置"></el-input>
      </el-form-item>
      <el-form-item label="标记">
        <el-select v-model="formInline.customerTag" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option v-for="item in customerTagList" :label="item.tagName" :value='item.tag'
            :key="item.tag"></el-option>
          <!-- <el-option label="重点客户-项目" :value='1'></el-option>
          <el-option label="重点客户-非项目" :value='2'></el-option>
          <el-option label="重点新客" :value='4'></el-option>
          <el-option label="项目客户" :value='5'></el-option>
          <el-option label="重点客户" :value='6'></el-option>
          <el-option label="主动营销" :value='8'></el-option>
          <el-option label="被动营销" :value='9'></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="客户ID：">
        <el-input maxlength='450' @input="changCustomerId" v-model="formInline.customerId"
          placeholder="请填入客户ID"></el-input>
      </el-form-item>
      <el-form-item label="是否可越库" v-if="prentType == 'smallBag'">
        <el-select v-model="formInline.crossDockingFlag" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option label="可越库" :value='1'></el-option>
          <el-option label="不可越库" :value='0'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="货代公司">
        <el-select v-model="formInline.wmsIntForwarderConfigId" placeholder="请选择" filterable>
          <el-option :label="item.forwarder + '-' + item.shippingType" :value="item.intForwarderConfigId"
            v-for="item in forwarder" :key="item.intForwarderConfigId" style="max-width: 300px"
            :title="item.forwarder + '-' + item.shippingType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="tiktok 时效标签" v-if="prentType == 'smallBag'">
        <el-select v-model="formInline.tiktokStatusTags" placeholder="请选择" multiple style="width: 300px;">
            <el-option value="01" label="距截止发货时间12h内订单"></el-option>
            <el-option value="02" label="距截止发货时间12h-24h内订单"></el-option>
            <el-option value="03" label="距截止发货时间24h-36h内订单"></el-option>
            <el-option value="04" label="距截止发货时间36h-48h内订单"></el-option>
            <el-option value="05" label="距截止发货时间48h-72h内订单"></el-option>
            <el-option value="06" label="距截止发货时间超72h订单"></el-option>
            <el-option value="07" label="超时未发"></el-option>
            <el-option value="08" label="超时已发"></el-option>
            <el-option value="09" label="时效内发货"></el-option>
            <el-option value="10" label="取消发货"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <BatchSearchDialog ref="batchSearchDialog" @search="batchSearch" />
  </div>
</template>

<script>
import Calendar from "@/utils/calendar";
import BatchSearchDialog from '@/components/BatchSearchDialog/index.vue'
import { getShopList, getCustomerShopListApi, forwarderList_outStock } from "@/apis/outStock";
import { listCustomerTasEnum } from "@/apis/auth"
import moment from "moment"
export default {
  name: "InterForm",
  components: { BatchSearchDialog },
  props: {
    isToBeProcessed: {
      type: Boolean,
      default: (_) => false,
    },
    prentType: {
      type: String,
      required: true,
    },
    shopList: {
      type: Array,
      required: true,
    },
    tableType: {
      type: String
    },
    countryList: {
      type: Array,
      default: (_) => [],
    }
  },
  data() {
    return {
      customerTagList: [],
      storeList: [],
      forwarder: [],
      formInline: {
        deliveryTaskCode: "",
        shopName: "",
        // canDelivery: '', 去动态添加
        // singleProduct: 0,  去动态添加
        createDate: null,
        endConfirmTimeStart: null,
        endConfirmTimeEnd: null,
        tiktokStatusTags: []
      },
    };
  },
  created() {
    if (this.isToBeProcessed) {
      this.$set(this.formInline, "canDelivery", "");
    }
    if (this.prentType === "smallBag") {
      this.$set(this.formInline, "singleProduct", undefined);
    }
    this.$emit("querySubmit", this.formInline);
    listCustomerTasEnum().then(res => {
      this.customerTagList = res.data ?? []
    })
  },
  watch: {
    // shopList: {
    //   deep: true,
    //   immediate: true,
    //   handler: function (newVal) {
    //     this.storeList = newVal.map(item => {
    //       return       {
    //         label: item.customerShopName,
    //         value: item.customerShopId
    //       }
    //     })
    //   }
    // }
  },
  mounted() {
    forwarderList_outStock().then(({ code, data }) => {
      if (code === 0) {
        this.forwarder = data;
      }
    });
  },
  methods: {

    changCustomerId(val) {
      this.formInline.customerId = val?.replace(/[^\d]/g, '')
    },
    cascaderChang: function (val) {
      // formInline.shopName
    },
    remoteMethod(val) {
      if (!val) {
        return;
      }
      console.log(val);
      getCustomerShopListApi({
        pageSize: 10000,
        pageNum: 1,
        customerShopName: val
      }).then((res) => {
        console.log(res)
        this.storeList = res.data.records;
      });
    },
    timeChange: function (val) {
      if (!val) {
        this.formInline.endConfirmTimeStart = null;
        this.formInline.endConfirmTimeEnd = null;
        return;
      }
      this.formInline.endConfirmTimeStart = moment(val[0]).format("YYYY-MM-DD");
      this.formInline.endConfirmTimeEnd = moment(val[1]).format("YYYY-MM-DD");
    },
    deliveryTimeChange: function (val) {
      if (!val) {
        this.formInline.deliveryStartTime = null;
        this.formInline.deliveryEndTime = null;
        return;
      }
      this.formInline.deliveryStartTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss");
      this.formInline.deliveryEndTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss");
    },
    rtsSlaTimeChange(val) {
      if (!val) {
        this.formInline.rtsSlaTimeStart = null;
        this.formInline.rtsSlaTimeEnd = null;
        return;
      }
      this.formInline.rtsSlaTimeStart = moment(val[0]).unix();
      this.formInline.rtsSlaTimeEnd = moment(val[1]).unix();
    },
    packTimeChange: function (val) {
      if (!val) {
        this.formInline.packStartTime = null;
        this.formInline.packEndTime = null;
        return;
      }
      this.formInline.packStartTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss");
      this.formInline.packEndTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss");
    },
    onSubmit: function (e, type = "") {
      this.$emit("querySubmit", this.formInline);
    },
    restSubmit: function () {
      Object.keys(this.formInline).forEach(key => { this.formInline[key] = undefined })
      // this.formInline.singleProduct = this.prentType === "smallBag" ? 0 : '',
      this.onSubmit(undefined, "rest");
    },
    dblclick(key) {
      console.log(this.$refs.batchSearchDialog)
      this.$refs.batchSearchDialog.open({ key })
    },
    batchSearch(params) {
      this.formInline = {
        ...this.formInline,
        ...params
      }
      // this.formInline.deliveryTaskCodeList && (this.formInline.deliveryTaskCodeList = this.formInline.deliveryTaskCodeList.split(','))
      this.$emit("querySubmit", this.formInline);
    }
  }
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
